module.exports = __webpack_public_path__ + "static/media/modal_mixed_icon.bab463b6.svg";